// frontend/src/services/pantallaInformativaService.js
import axios from 'axios';
import apiClient from './apiClient';

const BASE = '/pantalla-informativa';

/**
 * Pantalla informativa (TV de la sala de espera).
 *
 * Lo que lee el TV NO usa apiClient, a propósito (mismo criterio que encuestaService):
 *
 *  1. El TV no tiene usuario logueado: se autentica con la clave del link, en el header
 *     X-Pantalla-Clave. Si en ese navegador hay un JWT de recepción, no tiene por qué viajar.
 *  2. apiClient, ante un 401, borra el token y redirige a /login. En el TV eso dejaría la pantalla
 *     de login a la vista de toda la sala; un 401 acá se muestra como "pantalla no autorizada".
 *
 * La configuración sí usa apiClient: se edita desde Atención, con sesión.
 */

/** Las colas de espera y lo que se muestra al lado (videos, mensaje, modo y control). */
export async function obtenerPantalla(clave) {
    const { data } = await axios.get(`/api${BASE}`, {
        headers: { 'X-Pantalla-Clave': clave || '' },
    });
    return data;
}

/**
 * El TV cuenta qué video está pasando ({ idVideo, titulo, estado }). La respuesta es el control
 * remoto del video: así una pausa desde Atención llega en segundos.
 */
export async function enviarLatido(clave, estado) {
    const { data } = await axios.post(`/api${BASE}/latido`, estado, {
        headers: { 'X-Pantalla-Clave': clave || '' },
    });
    return data;
}

export async function obtenerConfiguracionPantalla() {
    const { data } = await apiClient.get(`${BASE}/configuracion`);
    return data;
}

export async function guardarConfiguracionPantalla(configuracion) {
    const { data } = await apiClient.put(`${BASE}/configuracion`, configuracion);
    return data;
}

/** Genera una clave nueva: el link anterior deja de funcionar. */
export async function regenerarClavePantalla() {
    const { data } = await apiClient.post(`${BASE}/configuracion/regenerar-clave`);
    return data;
}

/** Qué está pasando el TV ahora, según su último latido. */
export async function obtenerEstadoTv() {
    const { data } = await apiClient.get(`${BASE}/configuracion/estado-tv`);
    return data;
}

/** Control remoto del video: PAUSAR, REANUDAR, SIGUIENTE, ANTERIOR o REPRODUCIR (con idVideo). */
export async function enviarControlPantalla(accion, idVideo = null) {
    const { data } = await apiClient.post(`${BASE}/configuracion/control`, { accion, idVideo });
    return data;
}

/** El link que se abre en el TV. La clave va en el fragmento (#), que no se manda al servidor. */
export function linkPantalla(clave) {
    return `${window.location.origin}/tv-screen#clave=${encodeURIComponent(clave || '')}`;
}
